import * as moment from "moment"; // Needed For moment.preciseDiff() to work

export class PreciseDiff {
	public static STRINGS: any = {
		nodiff: "",
		year: "year",
		years: "years",
		month: "month",
		months: "months",
		day: "day",
		days: "days",
		hour: "hour",
		hours: "hours",
		minute: "minute",
		minutes: "minutes",
		second: "second",
		seconds: "seconds",
		delimiter: " ",
	};

	public static preciseDiff(d1: any, d2: any, returnValueObject: boolean) {
		var m1 = moment(d1);
		var m2 = moment(d2);
		var firstDateWasLater = false;

		m1.add(m2.utcOffset() - m1.utcOffset(), "minutes"); // shift timezone of m1 to m2

		if (m1.isSame(m2)) {
			if (returnValueObject) {
				return this.buildValueObject(0, 0, 0, 0, 0, 0, false);
			} else {
				return PreciseDiff.STRINGS.nodiff;
			}
		}
		if (m1.isAfter(m2)) {
			var tmp = m1;
			m1 = m2;
			m2 = tmp;
			firstDateWasLater = true;
		} else {
			firstDateWasLater = false;
		}

		var yDiff = m2.year() - m1.year();
		var mDiff = m2.month() - m1.month();
		var dDiff = m2.date() - m1.date();
		var hourDiff = m2.hour() - m1.hour();
		var minDiff = m2.minute() - m1.minute();
		var secDiff = m2.second() - m1.second();

		if (secDiff < 0) {
			secDiff = 60 + secDiff;
			minDiff--;
		}
		if (minDiff < 0) {
			minDiff = 60 + minDiff;
			hourDiff--;
		}
		if (hourDiff < 0) {
			hourDiff = 24 + hourDiff;
			dDiff--;
		}
		if (dDiff < 0) {
			var daysInLastFullMonth = moment(m2.year() + "-" + (m2.month() + 1), "YYYY-MM")
				.subtract(1, "M")
				.daysInMonth();
			if (daysInLastFullMonth < m1.date()) {
				// 31/01 -> 2/03
				dDiff = daysInLastFullMonth + dDiff + (m1.date() - daysInLastFullMonth);
			} else {
				dDiff = daysInLastFullMonth + dDiff;
			}
			mDiff--;
		}
		if (mDiff < 0) {
			mDiff = 12 + mDiff;
			yDiff--;
		}

		if (returnValueObject) {
			return this.buildValueObject(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff, firstDateWasLater);
		} else {
			return this.buildStringFromValues(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff);
		}
	}

	public static buildValueObject(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff, firstDateWasLater) {
		return {
			years: yDiff,
			months: mDiff,
			days: dDiff,
			hours: hourDiff,
			minutes: minDiff,
			seconds: secDiff,
			firstDateWasLater: firstDateWasLater,
		};
	}

	public static buildStringFromValues(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff) {
		var result = [];

		if (yDiff) {
			result.push(this.pluralize(yDiff, "year"));
		}
		if (mDiff) {
			result.push(this.pluralize(mDiff, "month"));
		}
		if (dDiff) {
			result.push(this.pluralize(dDiff, "day"));
		}
		if (hourDiff) {
			result.push(this.pluralize(hourDiff, "hour"));
		}
		if (minDiff) {
			result.push(this.pluralize(minDiff, "minute"));
		}
		if (secDiff) {
			result.push(this.pluralize(secDiff, "second"));
		}

		return result.join(PreciseDiff.STRINGS.delimiter);
	}

	public static pluralize(num, word) {
		return num + " " + PreciseDiff.STRINGS[word + (num === 1 ? "" : "s")];
	}
}
